import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12 mt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Info */}
          <div>
            <div className="mb-4">
              <img
                src="/images/companylogo.jpg"
                alt="JobsInDelhiNCR"
                className="h-10 sm:h-12 md:h-14 lg:h-16 object-contain"
              />
            </div>

            <p className="text-gray-400 mb-4">
              Connecting talent with opportunities across Delhi, Noida,
              Ghaziabad, Gurugram and the entire NCR region.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61583802745684"
                className="text-gray-400 hover:text-white transition duration-300  "
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/jobs.in.delhi.ncr?igsh=Y3Y2NjJpNDJ3MG12"
                className="text-gray-400 hover:text-white transition duration-300  "
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://youtube.com/@jobsindelhincr-t4p?si=8pBE6a5iRkxInyxY"
                className="text-gray-400 hover:text-white transition duration-300  "
              >
                <i className="fab fa-youtube"></i>
              </a>
                <a
                href="https://www.linkedin.com/in/jobs-in-delhi-ncr-0b2541389?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                className="text-gray-400 hover:text-white transition duration-300  "
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-400 hover:text-white">
                  Home
                </a>
              </li>
              <li>
                <a href="/findjobs" className="text-gray-400 hover:text-white">
                  Browse Jobs
                </a>
              </li>
              <li>
                <a href="/companies" className="text-gray-400 hover:text-white">
                  Companies
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-white">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Job Categories */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Job Categories</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/findjobs?category=Technology"
                  className="text-gray-400 hover:text-white"
                >
                  Technology
                </a>
              </li>
              <li>
                <a
                  href="/findjobs?category=Marketing"
                  className="text-gray-400 hover:text-white"
                >
                  Marketing
                </a>
              </li>
              <li>
                <a
                  href="/findjobs?category=Design"
                  className="text-gray-400 hover:text-white"
                >
                  Design
                </a>
              </li>
              <li>
                <a
                  href="/findjobs?category=Finance"
                  className="text-gray-400 hover:text-white"
                >
                  Finance
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt mt-1 mr-3"></i>
                171, Sector 22, Faridabad, Haryana 121005, India
              </li>
              <li className="flex items-center">
                <i className="fas fa-envelope mr-3"></i>
                info.jobsindelhincr@gmail.com
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone-alt mr-3"></i>
                +91 9871428686
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone-alt mr-3"></i>
                +91 6207496170
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Keyword Section */}
        <div className="mt-10 pt-8 border-t border-gray-700">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-y-2 gap-x-4 text-sm text-gray-400 px-4 leading-relaxed">
            {/* City-based Jobs */}
            <a href="/jobs-in-delhi" className="hover:text-white">
              Jobs in Delhi
            </a>
            <a href="/jobs-in-noida" className="hover:text-white">
              Jobs in Noida
            </a>
            <a href="/jobs-in-gurugram" className="hover:text-white">
              Jobs in Gurugram
            </a>
            <a href="/jobs-in-faridabad" className="hover:text-white">
              Jobs in Faridabad
            </a>
            <a href="/jobs-in-ghaziabad" className="hover:text-white">
              Jobs in Ghaziabad
            </a>

            {/* IT Jobs */}
            <a href="/it-jobs-in-delhi" className="hover:text-white">
              IT Jobs in Delhi
            </a>
            <a href="/it-jobs-in-noida" className="hover:text-white">
              IT Jobs in Noida
            </a>
            <a href="/it-jobs-in-gurugram" className="hover:text-white">
              IT Jobs in Gurugram
            </a>
            <a href="/it-jobs-in-faridabad" className="hover:text-white">
              IT Jobs in Faridabad
            </a>
            <a href="/it-jobs-in-ghaziabad" className="hover:text-white">
              IT Jobs in Ghaziabad
            </a>

            {/* HR Jobs */}
            <a href="/hr-jobs-in-delhi" className="hover:text-white">
              HR Jobs in Delhi
            </a>
            <a href="/hr-jobs-in-noida" className="hover:text-white">
              HR Jobs in Noida
            </a>
            <a href="/hr-jobs-in-gurugram" className="hover:text-white">
              HR Jobs in Gurugram
            </a>
            <a href="/hr-jobs-in-faridabad" className="hover:text-white">
              HR Jobs in Faridabad
            </a>
            <a href="/hr-jobs-in-ghaziabad" className="hover:text-white">
              HR Jobs in Ghaziabad
            </a>

            {/* Digital Marketing Jobs */}
            <a
              href="/digitalmarketing-jobs-in-delhi"
              className="hover:text-white"
            >
              Digital Marketing Jobs in Delhi
            </a>
            <a
              href="/digitalmarketing-jobs-in-noida"
              className="hover:text-white"
            >
              Digital Marketing Jobs in Noida
            </a>
            <a
              href="/digitalmarketing-jobs-in-gurugram"
              className="hover:text-white"
            >
              Digital Marketing Jobs in Gurugram
            </a>
            <a
              href="/digitalmarketing-jobs-in-faridabad"
              className="hover:text-white"
            >
              Digital Marketing Jobs in Faridabad
            </a>
            <a
              href="/digitalmarketing-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              Digital Marketing Jobs in Ghaziabad
            </a>

            {/* Telecaller Jobs */}
            <a href="/telecaller-jobs-in-delhi" className="hover:text-white">
              Telecaller Jobs in Delhi
            </a>
            <a href="/telecaller-jobs-in-noida" className="hover:text-white">
              Telecaller Jobs in Noida
            </a>
            <a href="/telecaller-jobs-in-gurugram" className="hover:text-white">
              Telecaller Jobs in Gurugram
            </a>
            <a
              href="/telecaller-jobs-in-faridabad"
              className="hover:text-white"
            >
              Telecaller Jobs in Faridabad
            </a>
            <a
              href="/telecaller-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              Telecaller Jobs in Ghaziabad
            </a>

            {/* Software Development Jobs */}
            <a
              href="/softwaredevelopment-jobs-in-delhi"
              className="hover:text-white"
            >
              Software Development Jobs in Delhi
            </a>
            <a
              href="/softwaredevelopment-jobs-in-noida"
              className="hover:text-white"
            >
              Software Development Jobs in Noida
            </a>
            <a
              href="/softwaredevelopment-jobs-in-gurugram"
              className="hover:text-white"
            >
              Software Development Jobs in Gurugram
            </a>
            <a
              href="/softwaredevelopment-jobs-in-faridabad"
              className="hover:text-white"
            >
              Software Development Jobs in Faridabad
            </a>
            <a
              href="/softwaredevelopment-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              Software Development Jobs in Ghaziabad
            </a>

            {/* Web Development Jobs */}
            <a
              href="/webdevelopment-jobs-in-delhi"
              className="hover:text-white"
            >
              Web Development Jobs in Delhi
            </a>
            <a
              href="/webdevelopment-jobs-in-noida"
              className="hover:text-white"
            >
              Web Development Jobs in Noida
            </a>
            <a
              href="/webdevelopment-jobs-in-gurugram"
              className="hover:text-white"
            >
              Web Development Jobs in Gurugram
            </a>
            <a
              href="/webdevelopment-jobs-in-faridabad"
              className="hover:text-white"
            >
              Web Development Jobs in Faridabad
            </a>
            <a
              href="/webdevelopment-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              Web Development Jobs in Ghaziabad
            </a>

            {/* App Development Jobs */}
            <a
              href="/appdevelopment-jobs-in-delhi"
              className="hover:text-white"
            >
              App Development Jobs in Delhi
            </a>
            <a
              href="/appdevelopment-jobs-in-noida"
              className="hover:text-white"
            >
              App Development Jobs in Noida
            </a>
            <a
              href="/appdevelopment-jobs-in-gurugram"
              className="hover:text-white"
            >
              App Development Jobs in Gurugram
            </a>
            <a
              href="/appdevelopment-jobs-in-faridabad"
              className="hover:text-white"
            >
              App Development Jobs in Faridabad
            </a>
            <a
              href="/appdevelopment-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              App Development Jobs in Ghaziabad
            </a>

            {/* Technical Support Jobs */}
            <a
              href="/technicalsupport-jobs-in-delhi"
              className="hover:text-white"
            >
              Technical Support Jobs in Delhi
            </a>
            <a
              href="/technicalsupport-jobs-in-noida"
              className="hover:text-white"
            >
              Technical Support Jobs in Noida
            </a>
            <a
              href="/technicalsupport-jobs-in-gurugram"
              className="hover:text-white"
            >
              Technical Support Jobs in Gurugram
            </a>
            <a
              href="/technicalsupport-jobs-in-faridabad"
              className="hover:text-white"
            >
              Technical Support Jobs in Faridabad
            </a>
            <a
              href="/technicalsupport-jobs-in-ghaziabad"
              className="hover:text-white"
            >
              Technical Support Jobs in Ghaziabad
            </a>

            {/* Fresher Jobs */}
            <a href="/fresher-jobs-in-delhi" className="hover:text-white">
              Fresher Jobs in Delhi
            </a>
            <a href="/fresher-jobs-in-noida" className="hover:text-white">
              Fresher Jobs in Noida
            </a>
            <a href="/fresher-jobs-in-gurugram" className="hover:text-white">
              Fresher Jobs in Gurugram
            </a>
            <a href="/fresher-jobs-in-faridabad" className="hover:text-white">
              Fresher Jobs in Faridabad
            </a>
            <a href="/fresher-jobs-in-ghaziabad" className="hover:text-white">
              Fresher Jobs in Ghaziabad
            </a>

            {/* Fulltime Jobs */}
            <a href="/fresher-jobs-in-delhi" className="hover:text-white">
              Fulltime Jobs in Delhi
            </a>
            <a href="/fulltime-jobs-in-noida" className="hover:text-white">
              Fulltime Jobs in Noida
            </a>
            <a href="/fulltime-jobs-in-gurugram" className="hover:text-white">
              Fulltime Jobs in Gurugram
            </a>
            <a href="/fulltime-jobs-in-faridabad" className="hover:text-white">
              Fulltime Jobs in Faridabad
            </a>
            <a href="/fulltime-jobs-in-ghaziabad" className="hover:text-white">
              Fulltime Jobs in Ghaziabad
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-white-700">
            © {new Date().getFullYear()} JobsInDelhiNCR. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
